import { render, staticRenderFns } from "./ListagemAtasCollapses.vue?vue&type=template&id=242b026f"
import script from "./ListagemAtasCollapses.vue?vue&type=script&lang=js"
export * from "./ListagemAtasCollapses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports